import React from "react";
import Header from '../../toolbars/Header';

export default function StaticHeader({ children, ...props }) {
  return (
    <React.Fragment>
      <Header
        clear={() => this.content.clearSelection()}
        version={props.version}
        setLoading={props.setLoading}
        handleMessage={props.handleMessage}
        error={props.error}
        setError={props.setError}
        naoExibirMenu={props.naoExibirMenu}>
      </Header>
      {children}
    </React.Fragment>
  );
}
